<template>
  <div class="login">
    <div class="login-box">
      <div class="login-head">
         <Head></Head>
       </div>
       <div class="login-main">
        <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="formData" @submit.native.prevent ref="login">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="formData.email"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input id="keydown" type="password" v-model="formData.password"></el-input>
                </el-form-item>
          </el-form>
         <!-- <div class="yz">
              <input type="text" v-model="formData.captcha" placeholder="请填写验证码" class="yanzheng" @focus="warningmsge=''">
              <img src="http://api.bioleaper.com.cn:6681/v1/verify" @click="captcha" alt="" class="yanzhengma" id="img">
          </div>   -->
         <button class="login-btn" @click="login">登录</button><a href="javascript:;" class="not-login" @click="()=>{this.$router.push('/forgetPassword')}">忘记密码？</a>
       </div>
    </div>
  </div>
</template>

<script>
import Head from "./components/loginhead"
import getUUID from '@/utils/getUUID'
import {mapMutations} from 'vuex'
export default {
  data (){
    return{
      formData:{
        email:'',
        password:'',
        captcha: '',
      },
      labelPosition: "right",
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        password:[
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^[^\s]{5,12}$/, message: '长度为5-12位，无空格', trigger: 'change' }
        ]
      },
      // captchaPath: '',
      // noCaptcha: true,
    }
  },
  components:{
    Head
  },
  mounted(){
    var that = this
    document.getElementById('keydown').addEventListener('keydown',that.keyDown)
  },
   methods: {
    login() {
      this.$api.main
        .login({
          email: this.formData.email,
          password: this.formData.password,
          captcha: this.formData.captcha
        })
        .then((res) => {
          if (res.status === 1) {
             this.$router.push('/')
             this.$store.dispatch('userLogin',true)
             localStorage.setItem('Flag','isLogin')
             localStorage.setItem('token',res.data.token)
          }else{
            if(res.msg == '账号不存在'){
              this.$message.closeAll()
              this.$message.error('用户不存在，请先注册在登录')
            }else if(res.msg == '账户未激活'){
              this.$message.closeAll()
              this.$message.error('账户未激活，请先在邮箱中进行激活')
            }else{
              this.$message.closeAll()
              this.$message.error(res.msg)
            }
          }
        });
    },
    keyDown (e) {
      if (e.keyCode === 13) {
        this.login()
      }
    }
    // captcha() {
    //     document.getElementById("img").src="http://api.bioleaper.com.cn:6681/v1/verify?"+Math.random();
    // }
  }
}
</script>

<style lang="less" scoped>
.login{
  width: 1920px;
  height:100vh;
  background: url("http://office.bioleaper.com.cn:6681/static/images/bg-login.jpg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  /deep/.el-form-item__label{
    text-align: left !important;
  }
  /deep/ .el-form-item{
    margin-top: 50px;
  }
  .login-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height:800px;
    width: 1200px;
    background: #fff;
    border-radius: 9px 9px 9px 9px;
    .login-head{
      width: 1200px;
      height:117px;
    }
    .login-main{
      width: 553px;
      height: 21px;
      font-size: 16px;
      text-align: left;
      color: #333333;
      letter-spacing: 1px;
      margin-left: 300px;
      margin-top: 61px;
      .checked{
        width: 600px;
        height: 40px;
        margin-top: 36px;
        .checkbox{
          width: 12px;
          height: 12px;
          background: #ffffff;
          border: 1px solid #d8d8d8;
        }
        span{
          font-size: 12px;
          text-align: left;
          color: #333333;
          letter-spacing: 1px;
        }
        .checked-text{
          width: 195px;
          height: 16px;
          margin-left: 7px;
        }
        .not-register{
          width: 65px;
          height: 16px;
          margin-left: 321px;
        }
      }
      .login-btn{
        width: 400px;
        height: 40px;
        background: #ffbb00;
        color:#003871;
        margin-top: 84px;
      }
      button{
        border:0px
      }
       .not-login{
        margin-left:40px;
        cursor: poiner;
       }
    }
  }
}
</style>